// Read-only rendering of NumberInput values (FormSummary, submission Review).
// Mirrors kakashi NumberInput's display: comma-grouped integer part, decimals
// preserved as entered. Returns null when the value is not numeric so callers
// can fall back to their generic formatting.

type NumberDisplayProps = {
  format?: unknown;
  formatWithCommas?: unknown;
};

const toNumber = (value: unknown): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string') {
    const trimmed = value.trim().replace(/,/g, '');
    if (trimmed === '') return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const formatNumberWithCommas = (value: number): string => {
  const [integerPart, decimalPart] = value.toString().split('.');
  const formattedInteger = Number(integerPart).toLocaleString('en-US');
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

export const formatNumberForDisplay = (
  value: unknown,
  props?: NumberDisplayProps
): string | null => {
  const numeric = toNumber(value);
  if (numeric === null) return null;
  const withCommas = props?.formatWithCommas !== false;
  const base = withCommas ? formatNumberWithCommas(numeric) : String(numeric);
  return props?.format === 'percentage' ? `${base}%` : base;
};
